<template>
	<v-app id="zarinpalCallback-view" fluid tag="section">
		<v-app-bar color="secondary" dark dense style="max-height: 48px">
			<a href="/" class="d-flex align-center">
				<img src="/logo-wide.png" style="max-width: 80px; max-height: 32px" class="hidden-sm-and-down" />

				<!-- نسخه کوچکتر برای موبایل -->
				<img src="/logo-wide.png" style="max-width: 60px; max-height: 28px" class="hidden-md-and-up" />
			</a>
			<div class="">
				<strong>اعتبارسنجی و پردازش پرداخت آنلاین</strong>
				&nbsp;&nbsp;
				<span class="warning--text text-truncate">{{ longTitle }}</span>
			</div>
			<v-spacer />
			<v-btn color="#000" elevation="0" dark small @click="returnToPanel">
				<v-icon left color="#fff">mdi-account-outline</v-icon>
				ورود به پنل کاربری
			</v-btn>
		</v-app-bar>
		<v-container>
			<v-row align="center" justify="center">
				<v-col cols="10" md="6">
					<v-card ref="card" class="mx-auto my-12">
						<div class="d-flex flex-column justify-center align-center" style="height:200px;" :style="{ 'background-color': bg }">
							<v-icon size="large" :color="color" style="font-size: 100px;">
								{{ icon }}
							</v-icon>
							<p :style="{ color: color }">{{ title }}</p>
						</div>
						<div class="form-group text-center py-5">
							<div v-if="message" v-html="message">

							</div>
							<p v-if="!isSuccess && isSuccess != null" class="grey--text px-5 pt-10"><small>در صورت کسر وجه٬ تراکنش به طور خودکار و حداکثر تا ۷۲ ساعت به حساب شما بازگشت داده ميشود. در صورت بروز مشکل پس از زمان مذکور با ما تماس بگيريد.</small></p>
						</div>
						<v-card-actions class="my-10">
							<v-spacer />
							<v-btn ref="submit" color="secondary" :loading="loading" dark @click="returnToPanel()">
								بازگشت به پنل کاربری
							</v-btn>
							<v-spacer />
						</v-card-actions>
					</v-card>
				</v-col>
			</v-row>
		</v-container>
	</v-app>
</template>

<script>
import GatewayService from '@/services/gateway.service'
import { get } from 'vuex-pathify'
import ThemeManager from '@/util/theme-manager.js'

export default {
	name: 'sepMemebrCallback',
	data() {
		return {
			id: '',
			data: { state: '', status: 0, mID: '', refNum: '', securePan: '', rRN: '', traceNo: '' },
			loading: false,
			isSuccess: null,
			message: '',
		}
	},
	computed: {
		...get('siteConfig', [
			'longTitle'
		]),
		bg() {
			if (this.loading)
				return '#dadada'
			if (this.isSuccess)
				return 'rgb(182 255 193)'
			return 'rgb(255 227 227)'
		},
		color() {
			if (this.loading)
				return '#aaa'
			if (this.isSuccess)
				return '#0dd400'
			return '#ff5722'
		},
		icon() {
			if (this.loading)
				return 'mdi-timer-sand'
			if (this.isSuccess)
				return 'mdi-credit-card-check'
			return 'mdi-alert-circle-outline'
		},
		title() {
			if (this.loading)
				return 'در حال بررسی'
			if (this.isSuccess)
				return 'پرداخت موفق'
			return 'پرداخت ناموفق'
		}
	},
	created() {
		ThemeManager.ApplyThemeSettings(this.$route.params.customerCode || 0, this.$vuetify)
	},
	mounted() {
		this.data.state = this.$route.query.State
		this.data.status = this.$route.query.Status
		this.data.mID = this.$route.query.MID
		this.data.resNum = this.$route.query.ResNum
		this.data.terminalId = this.$route.query.TerminalId
		this.data.refNum = this.$route.query.RefNum
		this.data.securePan = this.$route.query.SecurePan
		this.data.rRN = this.$route.query.RRN
		this.data.traceNo = this.$route.query.TraceNo
		if (!this.data.status && this.data.status != 0) {
			this.isSuccess = false
			this.message = 'پارامترهای مورد نیاز یافت نشدند.'
			return
		}
		this.verify()
		// this.$refs.password.$el.querySelector('input').click()
	},
	methods: {
		verify() {
			this.message = 'لطفا تا پایان عملیات منتظر بمانید...'
			this.loading = true
			GatewayService.memberVerifySep(this.data).then(
				response => {
					this.loading = false
					this.isSuccess = true
					this.message = 'با تشکر، پرداخت شما با موفقیت انجام و ثبت شد.<br/>شماره تراکنش: ' + response
				})
				.catch(error => {
					this.isSuccess = false
					this.loading = false
					this.message = error.message || error.toString()
				})
		},
		returnToPanel() {
			this.$router.push('/member/dashboard')
		}
	},
}
</script>

<style scoped></style>
